export default {"src":"/_next/static/media/unified-talent-ecosystem.38fb60d8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};